import { t } from 'i18next';
import { cn, SHIMMER_CLASSES } from '../../../lib/styles';

export function Skeleton() {
  return (
    <div
      className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-2"
      aria-label={t('aria:loading')}
      aria-busy
      role="progressbar"
    >
      <div className={cn('h-4 w-full rounded-full', SHIMMER_CLASSES)} />
      <div className={cn('h-4 w-full rounded-full', SHIMMER_CLASSES)} />
      <div className={cn('h-4 w-full rounded-full', SHIMMER_CLASSES)} />
      <div className={cn('h-4 w-3/4 rounded-full', SHIMMER_CLASSES)} />
    </div>
  );
}
